import apiClient from '../config/api';

class HealthService {
  // API 5: Health Check (Full)
  async getHealth() {
    try {
      const response = await apiClient.get('/health');
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch health status');
    }
  }

  // API 6: Health Check (Liveness)
  async getLiveness() {
    try {
      const response = await apiClient.get('/health/liveness');
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch liveness status');
    }
  }

  // API 7: Health Check (Readiness)
  async getReadiness() {
    try {
      const response = await apiClient.get('/health/readiness');
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch readiness status');
    }
  }

  // API 30-31: Get Application Metrics
  async getMetrics() {
    try {
      const response = await apiClient.get('/metrics');
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch metrics');
    }
  }
  
  // Get Dashboard Statistics
  async getDashboardStats() {
    try {
      const response = await apiClient.get('/dashboard');
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch dashboard statistics');
    }
  }
}

export default new HealthService();
